/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LocationMigrationResultDto } from '../models/LocationMigrationResultDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class LocationMigrationService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns LocationMigrationResultDto OK
     * @throws ApiError
     */
    public postApiHousingLocationMigrationPreviewLocationMigration(): CancelablePromise<LocationMigrationResultDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/LocationMigration/PreviewLocationMigration',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @returns LocationMigrationResultDto OK
     * @throws ApiError
     */
    public postApiHousingLocationMigrationExecuteLocationMigration(): CancelablePromise<LocationMigrationResultDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/LocationMigration/ExecuteLocationMigration',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
